export default "__VITE_ASSET__CiA0aZZN__"